<article class="lum-page lum-c-channel-form-v2">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <header class="lum-page-header lum-page-header--sticky lum-page-header--card">
      <h2 class="lum-page-header__heading">
        <a routerLink="/channels/v2/list">Channels</a> /
        <ng-container *ngIf="!(loading$ | async); else headingWhenLoading">
          <ng-container *ngIf="currentChannel; else headingWhenNew">
            <a [routerLink]="['/channels/v2', currentChannel.id, 'view']">
              {{ currentChannel.label }}
            </a>
            / Edit
          </ng-container>
          <ng-template #headingWhenNew>New Channel</ng-template>
        </ng-container>
        <ng-template #headingWhenLoading>
          <mat-spinner class="d-inline-block" diameter="14"></mat-spinner>
        </ng-template>
      </h2>
      <div class="lum-page-header__actions">
        <button
          class="lum-button lum-button--primary"
          type="submit"
          [disabled]="form.invalid || (submitting$ | async)"
        >
          <mat-spinner
            *ngIf="submitting$ | async"
            [diameter]="14"
            class="mr-2"
          ></mat-spinner>
          Save
        </button>
      </div>
    </header>

    <div class="lum-page-content">
      <ng-container *ngIf="!(loading$ | async)">
        <div class="lum-page__card">
          <div class="row">
            <ng-container *ngIf="ftChannelTypeEnabled">
              <div class="col-6 col-xl-4">
                <div class="form-group">
                  <label class="lum-label">Channel Type</label>
                  <mat-select
                    formControlName="channelType"
                    class="lum-select"
                    (selectionChange)="onChannelTypeChange($event)"
                  >
                    <mat-option
                      *ngFor="let type of CChannelTypesLookUp; trackBy: trackByKey"
                      [value]="type.value"
                    >
                      {{ type.label }}
                    </mat-option>
                  </mat-select>
                </div>
              </div>
            </ng-container>
            <div class="col-6 col-xl-4">
              <div class="form-group">
                <label class="lum-label">Channel Label</label>
                <input type="text" class="text lum-input" formControlName="label" />
              </div>
            </div>
            <div class="col-6 col-xl-4" *ngIf="isNonSalesChannel">
              <div class="form-group">
                <label class="lum-label">Warehouse Group</label>
                <lum-location-warehouse-group-control
                  formControlName="warehouseGroupId"
                ></lum-location-warehouse-group-control>
              </div>
            </div>
            <div class="col-12 col-xl-6 order-xl-last">
              <div class="form-group">
                <label class="lum-label">Tags</label>
                <lum-tag-autocomplete-chip
                  [formArray]="tagIds"
                ></lum-tag-autocomplete-chip>
              </div>
            </div>
            <div class="col-12 col-xl-6">
              <div class="form-group">
                <label class="lum-label">Description</label>
                <textarea
                  class="text lum-input"
                  formControlName="description"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="form-group mb-0" *ngIf="!isFulfillmentChannel">
                <mat-checkbox
                  formControlName="isPOSChannel"
                  class="lum-checkbox py-3"
                  (change)="onTogglePosChannel($event)"
                  >Is Internal Sales Channel</mat-checkbox
                >
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="'red_DV-2964_automated_billing' | featureFlag">
          <div class="lum-page__card" *ngIf="!isFulfillmentChannel">
            <header class="py-3 mb-5">
              <h4>Settings</h4>
            </header>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <mat-slide-toggle
                    title="Create Invoice Automatically"
                    color="primary"
                    formControlName="autoCreateInvoiceEnabled"
                    (change)="onToggleAutoInvoice($event)"
                  ></mat-slide-toggle>
                  Create Invoice Automatically
                </div>
              </div>
              <div class="col-6">
                <div
                  class="form-group"
                  *ngIf="'red_DV-3147_edi_810_invoice_sync' | featureFlag"
                >
                  <mat-slide-toggle
                    title="Auto-sync EDI"
                    color="primary"
                    formControlName="autoSyncEdiEnabled"
                  ></mat-slide-toggle>
                  Auto-sync EDI
                  <small
                    >Automatically send EDI 810 after an Invoice is created</small
                  >
                </div>
              </div>
              <ng-container *ngIf="isAutoCreateInvoiceEnabled">
                <div class="col-6">
                  <div class="form-group">
                    <label>Invoice Type</label>
                    <lum-filter-client-purchase-order-type
                      label=""
                      [displayValue]="invoiceTypeLabelControl?.value || ''"
                      [disableDefaultValue]="true"
                      (selectInvoiceEvent)="onSetInvoiceType($event)"
                    >
                    </lum-filter-client-purchase-order-type>
                  </div>
                  <div class="form-group">
                    <label>Invoice Creation Timing</label>
                    <mat-select
                      formControlName="invoiceCreateTiming"
                      class="lum-select"
                    >
                      <mat-option
                        *ngFor="
                          let timing of invoiceCreateTimings;
                          trackBy: trackByKey
                        "
                        [value]="timing.key"
                      >
                        {{ timing.description }}
                      </mat-option>
                    </mat-select>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <!-- ORDER SOURCE BLOCK -->
        <section
          *ngIf="!posChannelEnabled && !isFulfillmentChannel"
          class="lum-page__card"
        >
          <header class="py-3 mb-5">
            <h4>Order Source</h4>
          </header>

          <div class="row">
            <div class="col-6">
              <div class="d-flex align-items-center gap-15 mb-4">
                <label
                  class="
                    form-group d-inline-flex gap-2 align-items-center cursor-pointer mb-0
                  "
                >
                  <mat-slide-toggle
                    title="Pull Orders"
                    color="primary"
                    formControlName="pullOrdersFromOms"
                    (change)="onTogglePullOrders($event)"
                  ></mat-slide-toggle>
                  PULL Sales Orders
                </label>
                <div *ngIf="shouldPullOrders && !isNonSalesChannel">
                  <div formGroupName="pullOrdersFromOmsOptions">
                    <mat-checkbox
                      formControlName="autoPushFulfillmentUpdatesToOrderSource"
                      class="lum-checkbox"
                    >
                      Automatically Push Fulfillment Updates to Order Source
                    </mat-checkbox>
                  </div>
                </div>
              </div>
              <ng-container *ngIf="shouldPullOrders">
                <div class="form-group">
                  <label class="lum-label">Pull Orders From</label>
                  <lum-app-integration-account-control
                    (onAppAccountSelect)="onAppAccountSelected($event)"
                    formControlName="pullOrderAppIntegrationAccountId"
                  ></lum-app-integration-account-control>
                  <small *ngIf="ediWebhookUrl" class="mt-2"
                    >Webhook URL: {{ ediWebhookUrl }}</small
                  >
                </div>
                <div class="form-group" *ngIf="showOmsStoresDropdown">
                  <label class="lum-label">OMS Store</label>
                  <lum-app-integration-account-oms-store-control
                    [appIntegrationAccountId]="selectedPullAppIntegrationAccountId"
                    [excludeUsedOmsStoreIds]="true"
                    formControlName="pullOrderOmsStoreId"
                  ></lum-app-integration-account-oms-store-control>
                </div>
              </ng-container>
            </div>
            <div class="col-6">
              <div class="d-flex align-items-center gap-15 mb-4" formGroupName="pullOrdersFromOmsOptions">
                <label
                  class="
                    form-group d-inline-flex gap-2 align-items-center cursor-pointer mb-0
                  "
                >
                  <mat-slide-toggle
                    title="Save Contact to CRM"
                    color="primary"
                    formControlName="saveContactToCrmFromIncomingOrders"
                  ></mat-slide-toggle>
                  Save contact to CRM from orders
                </label>
              </div>
            </div>
          </div>

          <ng-container *ngIf="shouldPullOrders">
            <div class="row mb-3" *ngIf="showChannelFilters">
              <div class="col-12">
                <section class="form-group">
                  <header>
                    <h5>Filter Incoming Orders</h5>
                    <small
                      >If at least one filter is set, then only orders that match
                      the filter(s) will be attached to this channel.</small
                    >
                  </header>
                  <lum-channel-form-filters
                    [formData]="form"
                  ></lum-channel-form-filters>
                </section>
              </div>
            </div>

            <ng-container
              *ngIf="'red_DV-3027_Integration_Field_Mapping' | featureFlag"
            >
              <hr />
              <div class="row">
                <div class="col-lg-12">
                  <section
                    class="form-group"
                    formGroupName="pullOrdersFromOmsOptions"
                  >
                    <header class="flex justify-content-between">
                      <h5>Incoming Custom Field Mapping</h5>

                      <button
                        class="lum-button lum-button--secondary"
                        type="button"
                        (click)="onAddIncomingCustomField()"
                      >
                        <i class="fas fa-plus"></i> Add Custom Field
                      </button>
                    </header>
                    <table
                      *ngIf="
                        incomingCustomFieldMappingFormArray.controls.length;
                        else emptyCustomFields
                      "
                      class="
                        lum-table lum-table--classic striped lum-c-channel-form-v2__custom-field-table
                      "
                    >
                      <thead>
                        <tr>
                          <th>Incoming Field</th>
                          <th>LUM Field</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody formArrayName="incomingCustomFieldMapping">
                        <tr
                          *ngFor="
                            let field of incomingCustomFieldMappingFormArray.controls;
                            let idx = index
                          "
                          [formGroupName]="idx"
                        >
                          <td class="text-right">
                            <input
                              type="text"
                              formControlName="incomingField"
                              class="lum-input"
                            />
                          </td>
                          <td class="text-right">
                            <input
                              type="text"
                              formControlName="lumField"
                              class="lum-input"
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              class="
                                lum-button lum-button--link text-red-500 text-large
                              "
                              (click)="onRemoveIncomingCustomFieldMapping(idx)"
                            >
                              <i class="fas fa-times"></i>
                              <span class="sr-only">Remove Row</span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </section>

        <!-- ORDER DESTINATION BLOCK -->
        <section
          *ngIf="ftEdiIntegrationEnabled && isNonSalesChannel"
          class="lum-page__card"
        >
          <header class="py-3 mb-5">
            <h4>Order Destination</h4>
          </header>

          <div class="row">
            <div class="col-6 form-group">
              <label
                class="
                  form-group d-inline-flex gap-2 align-items-center cursor-pointer
                "
              >
                <mat-slide-toggle
                  title="Push Orders Orders"
                  color="primary"
                  formControlName="pushOrdersToOms"
                  (change)="onTogglePushOrders($event)"
                ></mat-slide-toggle>
                Push Orders to Integration
              </label>
            </div>
          </div>

          <ng-container *ngIf="shouldPushOrders">
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label class="lum-label">Push Orders To</label>
                  <lum-app-integration-account-control
                    [appAccountType]="ediPushOrderToOmsAppTypes"
                    (onAppAccountSelect)="onPushOrderAppAccountSelected($event)"
                    formControlName="pushOrderAppIntegrationAccountId"
                  ></lum-app-integration-account-control>
                </div>
              </div>
              <div class="col-6">
                <div [hidden]="!showPushOrderOmsStoresDropdown" class="form-group">
                  <label class="lum-label">OMS Store</label>
                  <lum-app-integration-account-oms-store-control
                    [appIntegrationAccountId]="
                      selectedPushOrderAppIntegrationAccountId
                    "
                    [excludeUsedOmsStoreIds]="true"
                    formControlName="pushOrderOmsStoreId"
                  ></lum-app-integration-account-oms-store-control>
                </div>
              </div>
              <div class="col-6" *ngIf="shouldShowAutoPushOrderField">
                <div class="form-group" formGroupName="pushOrdersToOmsOptions">
                  <label class="lum-label"
                    >Automatically Push Posted Order After x Minutes</label
                  >
                  <input
                    type="number"
                    class="lum-input"
                    formControlName="autoPushOrderAfterMinutes"
                  />
                </div>
              </div>
              <div class="col-6">
                <div *ngIf="shouldSetShppingMethod" class="form-group">
                  <label class="lum-label"
                    >Default Push Order Shipping Method</label
                  >
                  <lum-app-integration-account-shipping-method-control
                    [appIntegrationAccountId]="
                      selectedPushOrderAppIntegrationAccountId
                    "
                    [excludeUsedOmsShippingMethodIds]="true"
                    [formControl]="omsShippingMethodIdControl"
                  ></lum-app-integration-account-shipping-method-control>
                </div>
              </div>
            </div>

            <!-- Show fulfillment updates option here for non-sales channel -->
            <div
              class="row"
              formGroupName="pushOrdersToOmsOptions"
              *ngIf="shouldPushOrders && !isFulfillmentChannel"
            >
              <div class="col-12">
                <div class="form-group">
                  <mat-checkbox
                    formControlName="autoPushFulfillmentUpdatesToOrderSource"
                    class="lum-checkbox py-3"
                  >
                    Automatically Push Fulfillment Updates to Order Source
                  </mat-checkbox>
                </div>
              </div>
            </div>

            <hr />
            <div class="row">
              <div class="col-12">
                <lum-channel-custom-fields
                  [form]="form"
                ></lum-channel-custom-fields>
              </div>
            </div>

            <ng-container
              *ngIf="'red_DV-3027_Integration_Field_Mapping' | featureFlag"
            >
              <hr />
              <div class="row">
                <div class="col-lg-12">
                  <section
                    class="form-group"
                    formGroupName="pushOrdersToOmsOptions"
                  >
                    <header class="flex justify-content-between">
                      <h5>Outgoing Custom Field Mapping</h5>
                      <button
                        class="lum-button lum-button--secondary"
                        type="button"
                        (click)="onAddPushOrderCustomField()"
                      >
                        <i class="fas fa-plus"></i> Add Custom Field Mapping
                      </button>
                    </header>
                    <table
                      *ngIf="
                        pushOrderCustomFieldMappingFormArray.controls.length;
                        else emptyCustomFields
                      "
                      class="
                        lum-table lum-table--classic striped lum-c-channel-form-v2__custom-field-table
                      "
                    >
                      <thead>
                        <tr>
                          <th>LUM Field</th>
                          <th>Push Field</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody formArrayName="pushOrderCustomFieldMapping">
                        <tr
                          *ngFor="
                            let field of pushOrderCustomFieldMappingFormArray.controls;
                            let idx = index
                          "
                          [formGroupName]="idx"
                        >
                          <td class="text-right">
                            <mat-select
                              class="lum-select text-left"
                              formControlName="lumField"
                            >
                              <mat-option
                                *ngFor="
                                  let value of form.get(
                                    'pullOrdersFromOmsOptions.incomingCustomFieldMapping'
                                  )?.value
                                    | channelOutgoingCustomFields
                                      : outgoingCustomFields;
                                  trackBy: trackByValue
                                "
                                [value]="value.field"
                                >{{ value.label }}</mat-option
                              >
                            </mat-select>
                          </td>
                          <td class="text-right">
                            <input
                              type="text"
                              formControlName="pushField"
                              class="lum-input"
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              class="
                                lum-button lum-button--link text-red-500 text-large
                              "
                              (click)="onRemovePushCustomFieldMapping(idx)"
                            >
                              <i class="fas fa-times"></i>
                              <span class="sr-only">Remove Row</span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </section>

        <!-- PUSH STOCKS BLOCK -->
        <section *ngIf="!isFulfillmentChannel" class="lum-page__card">
          <header class="py-3 mb-5 mb-5">
            <h4>Push Inventory Stocks And Unit Price</h4>
          </header>

          <div class="row">
            <div class="col-12 col-sm-5 col-md-6">
              <label
                class="
                  form-group d-inline-flex gap-2 align-items-center cursor-pointer
                "
              >
                <mat-slide-toggle
                  title="Push Stocks"
                  color="primary"
                  formControlName="pushStocksToOms"
                  (change)="onTogglePushStocks($event)"
                ></mat-slide-toggle>
                Push Stock to Integration
              </label>
            </div>
            <ng-container
              *ngIf="pushStocksToOmsEnabled"
              formGroupName="pushStocksToOmsOptions"
            >
              <div class="col-12 col-sm-7 col-md-6">
                <div class="form-group">
                  <mat-checkbox
                    formControlName="pushUnitCost"
                    class="lum-checkbox d-block"
                    (change)="onTogglePosChannel($event)"
                    >Push Unit Cost</mat-checkbox
                  >
                  <mat-checkbox
                    formControlName="includeIncomingStocksAsSellable"
                    class="lum-checkbox d-block"
                    (change)="onTogglePosChannel($event)"
                    >Include Incoming Stocks as Sellable</mat-checkbox
                  >
                  <mat-checkbox
                    formControlName="pushIncomingStocksFromSupplierPurchaseOrderEnabled"
                    class="lum-checkbox d-block"
                    (change)="onTogglePosChannel($event)"
                    >Push Incoming Stocks from Supplier Purchase
                    Orders</mat-checkbox
                  >
                </div>
              </div>
            </ng-container>

            <div
              *ngIf="pushStocksToOmsEnabled && isNonSalesChannel"
              class="col-12 col-md-6"
            >
              <div class="form-group">
                <label class="lum-label">Push Stock To Integration</label>
                <lum-app-integration-account-control
                  (onAppAccountSelect)="onAppAccountSelect($event)"
                  formControlName="pushStocksAppIntegrationAccountId"
                ></lum-app-integration-account-control>
              </div>

              <div
                class="form-group"
                *ngIf="'red_DV-3409_push_stock_inventory_location' | featureFlag"
              >
                <label class="lum-label">Inventory Location</label>
                <lum-app-integration-account-inventory-location-control
                  formControlName="pushStocksInventoryLocationId"
                  [appIntegrationAccountId]="
                    selectedPushStocksAppIntegrationAccountId
                  "
                ></lum-app-integration-account-inventory-location-control>
              </div>
            </div>
          </div>
        </section>
      </ng-container>
    </div>
  </form>
</article>

<ng-template #emptyCustomFields>
  <p class="text-center mt-5"><em>No custom fields configured.</em></p>
</ng-template>
